import type { FaireProductEntity } from "../../entity_types/product";

export const p_3m4yztk7bq: FaireProductEntity = {
  token: "p_3m4yztk7bq",
  type: "product",
  name: "Cat Design Metal Decorative Bowl",
  brandToken: "b_bp2qh0z57y",
  brandName: "Nai Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/ad8ea038a3d73b806b06f4fc12821a3647c9cd78d475b728f8817e160d346678.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1bab50d850a9f9885ed423f15f6d9b17628e956890952ab45b97896f3ea008f.jpeg",
  ],
  priceDollars: 2.76,
  description:
    "Cat themed Metal bowls appealing to cat lovers and complementing home decor \nThese bowl could be used to serve snacks,tapas any dry food,or just to keep your small items or jewelry ",
  tags: [],
  msrpDollars: 5.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:07.017Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
